// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media(max-width: 768px) {


    .file_field{
     margin-bottom:"20px"    !important;
    }


    /* .divs_textfield {
      margin-top:50px  !important
    } */
}`, "",{"version":3,"sources":["webpack://./src/components/common/TripDetailForm.css"],"names":[],"mappings":"AAAA;;;IAGI;KACC,kCAAkC;IACnC;;;IAGA;;OAEG;AACP","sourcesContent":["@media(max-width: 768px) {\r\n\r\n\r\n    .file_field{\r\n     margin-bottom:\"20px\"    !important;\r\n    }\r\n\r\n\r\n    /* .divs_textfield {\r\n      margin-top:50px  !important\r\n    } */\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
